/**
 * Polls the DOM for an element matching `selector`, resolving when found
 * or rejecting after `timeoutMs`.
 *
 * Tour-only: Shepherd.js operates on the global DOM, so direct
 * `document.querySelector` is necessary here. Do NOT use this in
 * regular components or services — use ViewChild / ElementRef instead.
 */
export function waitForElement(selector: string, timeoutMs = 2000): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const deadline = performance.now() + timeoutMs;
    (function check() {
      const el = document.querySelector(selector) as HTMLElement | null;
      if (el) return resolve(el);
      if (performance.now() > deadline) return reject(new Error(`${selector} not found`));
      setTimeout(check, 50);
    })();
  });
}
